import { usHoldingReasonWords, usReason } from './reason';

/** Read coverage only. Order, fill and cancel lifecycle labels remain separate. */
export function usReadStatus(
  resource: 'orders' | 'positions' | 'fills' | 'trades',
  state: 'unavailable' | 'stale' | 'incomplete',
  options: { reasons?: readonly string[]; detail?: string; context?: string } = {},
): { text: string; title: string } {
  const reasons = [...new Set(options.reasons ?? [])].filter(Boolean)
    .map(code => {
      const reason = usReason(code);
      // A holdings-read code (#1315) reads in the holding vocabulary's words.
      const holding = usHoldingReasonWords(code);
      if (reason === `Polymarket US is unavailable (${code})`) return holding ? `${holding} (${code})` : code;
      // Unknown evidence/coverage codes do not establish an account outage.
      return `${reason} (${code})`;
    });
  return {
    text: `Polymarket US ${resource} ${state}${options.context ? ` · ${options.context}` : ''}`,
    title: [...reasons, options.detail].filter(Boolean).join('. '),
  };
}
